import React from "react";

interface IconIProps {
  size?: string;
}

const ArrowSlimIcon = ({ size = "14" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.97994 10.3536C4.1752 10.5488 4.49179 10.5488 4.68705 10.3536L7.86903 7.17157C8.06429 6.97631 8.06429 6.65973 7.86903 6.46447C7.67377 6.2692 7.35719 6.2692 7.16192 6.46447L4.3335 9.29289L1.50507 6.46447C1.30981 6.2692 0.993224 6.2692 0.797962 6.46447C0.6027 6.65973 0.6027 6.97631 0.797962 7.17157L3.97994 10.3536ZM4.3335 0L3.8335 -2.18557e-08L3.8335 10L4.3335 10L4.8335 10L4.8335 2.18557e-08L4.3335 0Z"
        fill="#E37639"
      />
    </svg>
  );
};
export default ArrowSlimIcon;
